import { IonModal } from '@ionic/react';
import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const MajorTurnOffStyles = styled(OnboardingPage)``;
export const MajorTurnOffModalStyles = styled(IonModal)`
  --width: 280px;
  --min-width: 250px;
  --height: auto;
  --border-radius: 28px;
  --background: linear-gradient(0deg, #2b0e21 0%, #14111e 49.18%, #1e0f34 100%),
    #172026;
  --box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.05);

  .major-turn-off-img {
    display: block;
    width: 190px;
    aspect-ratio: 1.82;
    margin: 0 auto 20px;
  }

  .modal-wrapper {
    padding: 24px;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 20px 0 0;
  }
`;
